import FormFeedbackBanner from "../forms/FormFeedbackBanner";
import { Alert, Button } from "react-bootstrap";
import { useEmailVerificationViewModel } from './useEmailVerificationViewModel';

export const EmailVerificationNotice = ({ requiredForRegistration = false }: { requiredForRegistration?: boolean }) => {
  const { currentUser, busy, message, failed, verified, initialNotice, run } = useEmailVerificationViewModel({ requiredForRegistration });

  const feedback = message || (initialNotice === "sent" ? "Verification email sent. Check your inbox and spam folder." : initialNotice === "failed" ? "Your account is ready, but the verification email could not be sent. Please try again." : "");
  const feedbackFailed = message ? failed : initialNotice === "failed";
  if (!currentUser?.email || verified) return null;
  return <Alert variant="info" className="account-notices account-verification-notice">
    <strong>Verify your email</strong>
    <p>{requiredForRegistration ? "Verify your email before registering for a race." : "Confirm your email address. You can keep browsing while you verify."}</p>
    <p>{currentUser.email}</p>
    <div className="d-flex flex-wrap gap-2">
      <Button variant="outline-primary" disabled={busy || currentUser.emailVerified} onClick={() => void run("send")}>Send verification email</Button>
      <Button variant="outline-primary" disabled={busy} onClick={() => void run("refresh")}>I have verified my email</Button>
    </div>
    {!busy && feedback ? <FormFeedbackBanner tone={feedbackFailed ? "error" : "info"} messageKey={feedback}>
      {feedback}
    </FormFeedbackBanner> : null}
  </Alert>;
};
